<!-- =========================================================================================
  File Name: addProgramSidebarView.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }} PROGRAM</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
                <!-- LOCATION -->
        <label class="vs-select--label w-full">Location *</label>
        <v-select  label="name"   :closeOnSelect="true" v-model="Location"  :options="locations"  />
        <!-- NAME -->
        <vs-input label="Name *"   v-model="dataName" class="mt-5 w-full" name="name" v-validate="'required'" maxlength="50" />
        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span><br>

        <!-- COLOR PICKER -->
        <label>Select Color </label><br />
        <ul class="centerx mt-2 flex flex-wrap">
          <li class="ml-1" v-for="(color, index) in suggestcolors" :key="index">
         <vs-radio class="color_radio" :color="color"
          :style="{backgroundColor:color}" style="border-style:none" v-model="customPrimaryColor" :vs-value="color">{{
            }}</vs-radio>
          </li>
        </ul>
        <br />
        <!-- COLOR PICKER -->
        <div>
          <label class="mb-4" v-if="customPrimaryColor">Selected Color</label>
          <ul class="clearfix">
            <li
              :style="{ backgroundColor: customPrimaryColor }"
              :class="{ 'shadow-outline': customPrimaryColor == primaryColor }"
              class="w-10 cursor-pointer h-10 rounded-lg m-2 float-left"
            />
          </ul>
        </div>


<!--        <span class="text-danger text-sm" v-show="errors.has('item-category')">{{ errors.first('item-category') }}</span>-->

<!--        &lt;!&ndash; ORDER STATUS &ndash;&gt;-->
<!--        <vs-select v-model="dataCamUser" label="Cam User" class="mt-5 w-full">-->
<!--          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in order_status_choices" />-->
<!--        </vs-select>-->

<!--        &lt;!&ndash; ORDER STATUS &ndash;&gt;-->
<!--        <vs-select v-model="dataRoom" label="Rooms" class="mt-5 w-full">-->
<!--          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in rooms_choices" :multi="true" />-->
<!--        </vs-select>-->

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moduleDataList from '@/store/data-list/moduleDataList.js'
import {CREATE_PROGRAM} from '@/graphql'
import {UPDATE_PROGRAM} from '@/graphql'
import {ALL_LOCATIONS, SUGGEST_PROGRAM_COLOR} from '@/graphql'
import vSelect from 'vue-select'


export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    moduleDataList,
    vSelect
  },
  data () {
    return {
      dataId: null,
      dataName: '',
      Location:'',
      locations:[],
      suggestcolors:[],
      customPrimaryColor: '',
      primaryColor:'',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.getcolor('')
        this.initValues()
        this.$validator.reset()
      } else {
        const {id, name, location, color_code} = JSON.parse(JSON.stringify(this.data))
        this.getcolor(id)
        this.dataId = id
        this.dataName = name
        this.Location = location
        this.customPrimaryColor = color_code

        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    // locations () {
    //   return this.$store.state.dataList.locations
    // },
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.dataName
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    StatusSuccess (msg, color) {
      this.$vs.notify({
        title: 'Program',
        text: msg,
        color,
        position: 'top-right'
      })
    },
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
      this.Location = ''
      this.customPrimaryColor = ''
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          // const obj = {
          //   id: this.dataId,
          //   name: this.dataName,
          //   location: this.Location
          // }
          if (this.dataId !== null && this.dataId >= 0) {
            this.$apollo
              .mutate({
                mutation: UPDATE_PROGRAM,
                variables: {
                  id :this.dataId,
                  name: this.dataName,
                  color_code:this.customPrimaryColor,
                  location_id: this.Location.id
                }
              })
              .then(response => {
                if (response) {
                  this.StatusSuccess(response.data.updateProgram.message, response.data.updateProgram.color)
                  if (response.data.updateProgram.status == 'Success') {
                    this.$emit('closeSidebar')
                    this.initValues()
                  }

                }
              }).catch(error => {
              })
            // this.$store.dispatch('dataList/updateProgram', obj).catch(err => { console.error(err) })
          } else {
            this.$apollo
              .mutate({
                mutation: CREATE_PROGRAM,
                variables: {
                  name: this.dataName,
                  color_code:this.customPrimaryColor,
                  location_id: this.Location.id
                }
              })
              .then(response => {
                if (response) {
                  // console.log(response.data.createProgram.status)

                  this.StatusSuccess(response.data.createProgram.message, response.data.createProgram.color)
                  if (response.data.createProgram.status == 'Success') {
                    this.$emit('closeSidebar')
                    this.initValues()
                  }
                }
              }).catch(error => {


              })
            // delete obj.id
            // obj.popularity = 0
            // this.$store.dispatch('dataList/addProgram', obj).catch(err => { console.error(err) })
          }
        }
      })
    },
    updateCurrImg (input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.dataImg = e.target.result
        }
        reader.readAsDataURL(input.target.files[0])
      }
    },
    updatePrimaryColor (color) {
      this.primaryColor = color
      this.$vs.theme({ primary: color })
    },
    getcolor (id) {
      this.$apollo
        .mutate({
          mutation: SUGGEST_PROGRAM_COLOR,
          variables: {
            id
          }
        })
        .then((response) => {
          this.suggestcolors = response.data.suggestProgramColors.colors
        })

    }
  },
  created () {
    this.$apollo
      .mutate({
        mutation: ALL_LOCATIONS
      })
      .then(response => {
        this.locations = response.data.locations
      })

    // if (!moduleDataList.isRegistered) {
    //   this.$store.registerModule('dataList', moduleDataList)
    //   moduleDataList.isRegistered = true
    // }
    // this.$store.dispatch('dataList/fetchDataListLocation')
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
.color_radio {
        height: 16px;
        width: 16px;
        border-radius: 10px;
        border-style:none;


  }
</style>
